module.exports = __webpack_public_path__ + "static/media/CUHK_logo.10246936.png";